// Order matters: primary-tag fallback in detectLocale() picks the first match.
export const SUPPORTED_LOCALES = ['en', 'es-419', 'pt-PT', 'tr', 'de-DE', 'fr-FR', 'el-GR', 'ro'];
export const DEFAULT_LOCALE = 'en';